import { staticPageMetadata } from '../../lib/i18n/staticPageMetadata';
import { StatusBar } from 'expo-status-bar';
import { View, Text, StyleSheet, Platform } from 'react-native';
import React, { memo } from 'react';
import MainScreen from '../../components/MainScreen';
import MetaTags from '../../components/MetaTags';
import { useSession } from '../../lib/SessionContext';
import { SubscriptionProvider } from '../../lib/SubscriptionContext';
import { Trans } from '@lingui/react/macro';
import { msg } from '@lingui/core/macro';

// Import the static papers
let staticPapers: any[] = [];
try {
    staticPapers = require('../../assets/static-papers.json');
    console.log('📄 Loaded static papers:', staticPapers.length);
} catch (e) {
    console.log('📄 No static papers file found');
}

const MemoizedMainScreen = memo(MainScreen);

export default function Summarize() {
    const { session } = useSession();

    const initialPapers = Platform.OS === 'web' ? staticPapers : [];

    if (Platform.OS === 'web' && typeof window !== 'undefined') {
        console.log('📝 Summarize rendering, initialPapers:', initialPapers?.length);
    }

    return (
        <>
            <MetaTags
                surfaceId="summarize"
            />
            <View style={styles.container}>
                <Text
                    style={styles.srOnly}
                    accessibilityRole="header"
                    {...(Platform.OS === 'web' && { role: 'heading', 'aria-level': 1 })}
                ><Trans id="summarize.paperzillaPublicFeed" comment="UI copy in app/(public)/summarize.tsx">
                    Paperzilla Public Feed
                </Trans></Text>
                <SubscriptionProvider>
                    <MemoizedMainScreen
                        session={session}
                        initialPublicPapers={initialPapers}
                    />
                </SubscriptionProvider>
                <StatusBar style="auto" />
            </View>
        </>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#fff',
    },
    srOnly: {
        position: 'absolute',
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: 'hidden',
    },
});

export function generateMetadata() {
    return staticPageMetadata({ surfaceId: 'summarize' });
}
